import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { GruppeTier } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';

@Component({
    selector: 'kiene-abteil-dialog',
    templateUrl: './abteil-dialog.component.html',
    styleUrls: ['./abteil-dialog.component.scss'],
})
export class AbteilDialogComponent implements OnInit {
    tier: GruppeTier;

    constructor(
        public dialogRef: MatDialogRef<AbteilDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        @Inject(MAT_DIALOG_DATA) private data,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {
        this.tier = this.data.tier;
    }

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }

    save() {
        this.api.updateGeneric(this.apiBaseUrl + 'gruppe_tier/update_kundenportal.php', this.tier).subscribe({
            next: () => {
                this.messageService.infoMessage('Das Abteil wurde erfolgreich gespeichert!');
                this.close();
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }
}
